import classNames from "classnames";
import * as React from "react";
import {  IUIFieldProps, registerUIField } from "../../common";
import {  FieldTitle } from "../../components/FieldTitle";


import { BarChartUI, BarChartUIPropertyEditor, IBarChartUIFieldProperty } from "../../barchart-ui/BarChartUI";



export const Field: React.FunctionComponent<IUIFieldProps<IBarChartUIFieldProperty>> = (props) => {


	return (
		<div className={classNames('ui-field-map-ui ui-field', props.mode)} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {}} />

			<BarChartUI designer={props?.designer}
				{...props?.fieldProps}
				uxpContext={props.uxpContext}
				contextData={props.contextData}
				datasources={props.uiProps.datasources || []}
			/>
		</div >
	)
}


registerUIField({
	id: 'bar-chart',
	category: 'charts',
	description: 'Bar Chart',
	field: Field,
	isInputField: true,
	propertyEditor: BarChartUIPropertyEditor,
	defaultProps: {
		datasources:[],
		fieldLabel: {
			label: '',
		},
		appearance:{showGrid:true,showYAxis:true,showLegend:false,stackBars:true},
		chartItems:[],
		refreshInterval:'120000',
		sortData:{isTimeSeriesData:false,sortBy:'none',sortOrder:'asc'},
		timeseries:false,
		xField:'',
		
	},
	type: 'position',


});


